import React, { useState } from "react"

import { ResetPasswordForm } from "./Form"
import { ResetPasswordSubmittedScreenContent } from "./Submitted"
import { LanguageSelector } from "../../components"

export const ResetPasswordScreenContent = () => {
  const [isSubmitted, setIsSubmitted] = useState(false)

  return <>
    {isSubmitted ? <ResetPasswordSubmittedScreenContent/> :
      <ResetPasswordForm executeOnSuccess={() => setIsSubmitted(true)}/>}
    <LanguageSelector/>
  </>
}
